import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useQueryParam } from "../../pages/project/quote/pricing/QueryParam";
import { useDefaultTab } from "./useDefaultTab"; // useQueryParam for a tab control plus the user's default-tab preference.
// Drop-in replacement for `useQueryParam(urlKey, fallback)`:
//
//   const [tab, setTab, dt] = useTabQueryParam({page: "shopdrawing.openings", urlKey: "tab", fallback: "doors", allowed: ["frames", "doors", "all"]});
//   <Tab label="Doors" value="doors" {...dt.tabProps("doors")} />
//   {dt.controls}
//
// The query string means the same for everyone: a missing param is `fallback`.
// A stored default is written into the URL once per page visit instead.
export function useTabQueryParam(props) {
    const loc = useLocation();
    const nav = useNavigate();
    const urlKey = props.urlKey;
    const dt = useDefaultTab({ page: props.page, fallback: props.fallback, allowed: props.allowed });
    const hasParam = new URLSearchParams(loc.search).has(urlKey);
    const appliedFor = useRef(null);
    const pending = !hasParam && dt.defaultValue !== props.fallback && appliedFor.current !== loc.pathname; // render with the stored default right away so the fallback tab never mounts
    const [tab, setTab] = useQueryParam(urlKey, pending ? dt.defaultValue : props.fallback);
    useEffect(() => { if (!pending)
        return; appliedFor.current = loc.pathname; const search = new URLSearchParams(loc.search); search.set(urlKey, dt.defaultValue); nav({ pathname: loc.pathname, search: "?" + search.toString() }, { replace: true }); }, [pending, loc.pathname, loc.search, nav, urlKey, dt.defaultValue]);
    return [tab, setTab, dt];
}
